import type { ReactNode } from 'react';
import css from './Faixa.module.css';
import { Icone } from './Icone';

/** Faixa de 44 px no topo do conteúdo ("Atrasou 7 min: pedido às 18:33…"). Texto, não só cor. */
export function Faixa({ tom, children }: { tom: 'erro' | 'alerta'; children: ReactNode }) {
  return (
    <div className={`${css.faixa} ${css[tom]}`}>
      <Icone nome="alerta" tamanho={18} />
      <span className={css.texto}>{children}</span>
    </div>
  );
}
